<div class="title-with-ai-container">
  <div class="input-container">
    <input
      [formControl]="formControl"
      [formlyAttributes]="field"
      [id]="id"
      [maxLength]="props.maxLength"
      [placeholder]="props.placeholder || ''"
      [required]="props.required"
      (input)="onInput()"
      class="form-control"
      type="text"
    />

    <div class="input-icons">
      <!-- Loading spinner when generating -->
      <fa-icon
        *ngIf="isTitleGenerating$ | async"
        [icon]="['fas', 'spinner']"
        [ngbTooltip]="'Generating title suggestion...' | translate"
        class="icon-generating"
        animation="spin"
      >
      </fa-icon>

      <!-- AI robot icon for generating title -->
      <button
        #tooltip="ngbTooltip"
        *ngIf="(isTitleGenerating$ | async) !== true"
        [class.disabled]="formControl.disabled || !canGenerateTitle"
        [ngbTooltip]="
          canGenerateTitle
            ? ('Generate title suggestion' | translate)
            : ('Add more content before generating title' | translate)
        "
        [openDelay]="500"
        (click)="onGenerateTitleClick(tooltip)"
        class="btn btn-link ai-generate-btn"
        type="button"
      >
        <astrobin-sparkles-icon class="icon-ai me-0"></astrobin-sparkles-icon>
      </button>
    </div>
  </div>

  <!-- Suggestion pill -->
  <div *ngIf="hasPendingSuggestion && pendingSuggestion" class="suggestion-pill-container">
    <div class="suggestion-pill">
      <astrobin-sparkles-icon [height]="14" [width]="14"></astrobin-sparkles-icon>
      <span class="suggestion-text">{{ pendingSuggestion }}</span>
      <div class="suggestion-actions">
        <button
          [ngbTooltip]="'Accept suggestion' | translate"
          (click)="acceptSuggestion()"
          class="btn btn-link btn-sm accept-btn"
          type="button"
        >
          <fa-icon [icon]="['fas', 'check']"></fa-icon>
        </button>
        <button
          [ngbTooltip]="'Reject suggestion' | translate"
          (click)="rejectSuggestion()"
          class="btn btn-link btn-sm reject-btn"
          type="button"
        >
          <fa-icon [icon]="['fas', 'times']"></fa-icon>
        </button>
      </div>
    </div>
  </div>
</div>
